import React, { useEffect, useState } from "react";
import { LoadingButton } from "../Utils/CustomComponent";
import MultipleFormBoxComp from "../components/FormBox/MultipleFormBoxComp";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { surveyFormSchema } from "../Utils/formOptions";
import axios from "axios";
import urls from "../Utils/urls";
import { oracleConfig } from "../Utils/constant";

const CustomerSurveyForm = () => {
  const [submitLoading, setSubmitLoading] = useState(false);
  const { ticketId, ticketNumber } = useParams();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    mode: "onBlur",
    ...surveyFormSchema,
  });

  useEffect(() => {
    reset();
  }, [reset]);

  async function onSubmit(data) {
    setSubmitLoading(true);

    const payload = {
      ...data,
      ticketId: ticketId,
    };
    try {
      const res = await axios.post(
        urls.customerService.postSatisfactionFeedback,
        payload,
        oracleConfig
      );

      setSubmitLoading(false);
      navigate("/thankyou");
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <div style={{ background: "#eeeeee" }}>
      <div className="text-start container px-0">
        <div style={{ overflowY: "scroll" }}>
          <section
            className="rounded pb-5"
            style={{ background: "#eeeeee", minHeight: "100vh" }}
          >
            <article className="container-fluid">
              <div className="p-5 pb-0  mt-1">
                {/* <span
              className="linkClick"
              role="button"
              onClick={() => navigate(-1)}
            >
              <ArrowLeft size={20} /> Back
            </span> */}
              </div>
            </article>

            <article className="container-fluid">
              <section className="bg-white p-5 my-2 mx-4">
                <div className="row"></div>
                <h4 className="mt-5 fw-bold">Customer Satisfaction Survey</h4>
                <p className="text-muted">Ticket #TICKET-{ticketNumber}</p>

                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="px-5 mt-5">
                    {surveyForm?.map((data, index) => {
                      return (
                        <MultipleFormBoxComp
                          key={index}
                          register={register}
                          watch={watch}
                          setValue={setValue}
                          options={data.arr}
                          errors={errors}
                        />
                      );
                    })}
                    <div>
                      <LoadingButton
                        loading={submitLoading}
                        disabled={submitLoading}
                        type="submit"
                        title={"Submit"}
                      />
                    </div>
                  </div>
                </form>
              </section>
            </article>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CustomerSurveyForm;

export const surveyForm = [
  {
    field: "Customer Satisfaction Survey",
    arr: [
      {
        section: (
          <div>
            <h4>Rate Your Experience</h4>{" "}
            <p className="text-muted fs-6">
              How satisfied are you with the resolution of your ticket?
            </p>
          </div>
        ),
        className: "border p-5 mb-5",
        arr: [
          {
            field: "rating",
            type: "star",
            className: "col-12 pt-4",
            number: 5,
          },
          {
            type: "content",
            content: (
              <p className="text-danger pt-4">Please rate your experience</p>
            ),
          },
        ],
      },
      {
        section: (
          <div>
            <h4>Resolution Quality</h4>{" "}
            <p className="text-muted fs-6">
              How would you rate the quality of the resolution provided?
            </p>
          </div>
        ),
        className: "border p-5 mb-5",
        arr: [
          {
            title: "Resolution Quality",
            field: "resolutionQuality",
            type: "radio",
            className: "col-12",
            options: [
              {
                title: "Excellent - Completely resolved my issue",
                value: "Excellent",
              },
              { title: "Good - Mostly resolved my issue", value: "Good" },
              { title: "Fair - Partially resolved my issue", value: "Fair" },
              { title: "Poor - Did not resolve my issue", value: "Poor" },
            ],
          },
        ],
      },
      {
        section: (
          <div>
            <h4>Email Address ✉️ (Required)</h4>
            <p className="text-muted fs-6">
              Please enter your email so we can follow up if needed.
            </p>
          </div>
        ),
        className: "border p-5 mb-5",
        arr: [
          {
            title: "Enter your email",
            field: "email",
            type: "email",
            className: "col-12",
          },
        ],
      },
      {
        section: (
          <div>
            <h4>Additional Feedback</h4>{" "}
            <p className="text-muted fs-6">
              Please share any additional comments about your experience
              (optional)
            </p>
          </div>
        ),
        className: "border p-5 mb-5",
        arr: [
          {
            title: "Your feedback helps us improve our service...",
            field: "feedback",
            type: "textarea",
            className: "col-12",
          },
        ],
      },
    ],
  },
];
